import SciugoTextArea from "./SciugoTextArea";
import { useRef, useEffect, useContext, useState } from 'react';
import { SelectedItemInfo } from './SelectedItemProvider';
import { TemporaryCellValueContext } from './TemporaryCellValueProvider';
import { SelectedItemsContext } from './Contexts';
import { isMeasuredString } from './Letters';
import handleValueBarKeyDown from "./handleValueBarKeyDown";
import A from './ActionCreators';
import Dialogs from './DialogConstants';
import { useDispatch } from 'react-redux';

const isImageType = type => ['image','crop'].includes(type);
export const CELL_VALUE_INPUT = "cellValueInput";
export const CONSUME_ARROW_KEYS = "consumearrowkeys";


export default function TextValueBar({

  selectionJustMade,
  setSelectionJustMade,
  cellValueInputRef,
  focusedOnValueDisplayRef,
  retainInputFocus,
  figurePanelId


}){


  const dispatch = useDispatch();

  const { unifiedGroup } = useContext( SelectedItemInfo);
  const { temporaryCellValue, setTemporaryCellValue } = useContext(TemporaryCellValueContext);

  let selectedFigureItems = useContext(SelectedItemsContext);

  let { cells } = selectedFigureItems || {};

  let selectedCells = cells || [];


  let value = unifiedGroup.value;


  if( selectedCells.length === 0){
    value = "";
  }else if( temporaryCellValue !== null ){
    value = temporaryCellValue
  }
  else if( value instanceof Object && isImageType(value.valueType)){
    value = '📷';
  }else if( value instanceof Object && value.valueType === 'bandAnnotation' ){
    value = JSON.stringify(unifiedGroup.value);
  }


  
  

  


  const [clicked,setClicked] = useState(false);
  //let [lastSelectedCells,setLastSelectedCells] = useState(selCellsPropString);

  useEffect(() => {


    setClicked(false);
    
    setTemporaryCellValue(null);
    focusedOnValueDisplayRef && (
      focusedOnValueDisplayRef.current = false
    );

    if( cellValueInputRef.current ){
      console.log("DOING A FOCUS!");
      cellValueInputRef.current.focus();
      cellValueInputRef.current.select();

    }

  },[selectedCells])



  const setInputCursorValueRef = useRef(null);

  useEffect(() => {


    if( cellValueInputRef.current && setInputCursorValueRef.current !== null ){
      console.log("doing something with caret");
      let caretPos = setInputCursorValueRef.current
      cellValueInputRef.current.setSelectionRange(caretPos, caretPos);
      setInputCursorValueRef.current = null;
    }

    if( unifiedGroup.value !== undefined && cellValueInputRef && cellValueInputRef.current && !retainInputFocus ){

      if( selectionJustMade && !clicked ){

        console.log("DOING SOME SELECTION!");
        cellValueInputRef.current.select();
      }

    }
  })

  let inputStyle;
  let inputPlaceholder;

  if( !temporaryCellValue && value && value.multipleValues ){
    value="";
    inputPlaceholder = "Multiple values";
    inputStyle = { fontStyle:'italic' }
  }


  const computeRows = value => {
    if(value && !value.split){
      debugger;
    }else{
      return value?value.split('\n').length : 1
    }
  }


  return (

    <SciugoTextArea 
      name={CELL_VALUE_INPUT /*don't remove this or it will mess up the arrow key listener*/}
      consumeArrowKeys={String(clicked) /*don't remove this or it will mess up the arrow key listener*/}

      class="value-textarea"
      rows={computeRows(value)}
      textareaRef={cellValueInputRef}
      //ref={cellValueInputRef}
      value={value} 
      disabled={value===undefined||selectedCells.length === 0}

      onClick={() => {
        if( !focusedOnValueDisplayRef.current ){
          focusedOnValueDisplayRef.current = (true);
        }
        setClicked(true)
      }}
      onBlur={(e) => {

        setClicked(false);
        setSelectionJustMade(false);
        //setFocusedOnValueDisplay
        focusedOnValueDisplayRef.current = (false);

        if( temporaryCellValue!==null ){
          dispatch(A.setCellsValue({figurePanelId,cells:selectedCells,value:temporaryCellValue}));
          setTemporaryCellValue(null);
        }
      }}

      onKeyDown={e => handleValueBarKeyDown({e,clicked,setClicked, 
        curValue:value,
        setTemporaryCellValue,
        setInputCursorValueRef
      })}
      onChange={e=>{

        setSelectionJustMade(false);
        let string = e.target.value;



        if( value.valueType === 'image' ){
          if(string !== ''){
            return;
          }
        }

        if( !isMeasuredString( 
          Array.from(string).filter(x=>x!=='\n') ) ){
          dispatch(A.createDialog({
            source:'ValueDisplay',
            dialogName:Dialogs.ILLEGAL_CHARACTER_IN_CELL,
            args:{string}
          }))

        }else{ 
          setTemporaryCellValue(string);
        }
      }}
      placeholder={inputPlaceholder}
      style={{
        background:(selectionJustMade?'cyan':'white'),
        //border:selectionJustMade?'3px solid red':'auto',
        ...inputStyle,
        caretColor:((clicked||focusedOnValueDisplayRef.current)?'auto':'transparent')
      }}
    />

  )

}
